import React, { useState } from "react";
import { Trans } from "react-i18next";
import { Dialog, Spinner, Icon, Callout, Tag } from "@blueprintjs/core";

import { mefDate, mefPlate } from "../../../utils/mef";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { getSetting } from "../../Settings/InstallationSettings";
import Detection from "../DetectionClassification/Detection";

export default function PlateImage(props) {
  const [isOpen, open] = useState(false);
  const [isLoading, loading] = useState(false);
  const [image, setImage] = useState({});
  const [dataFetched, setFetched] = useState(false);

  if (
    getSetting("display ALPR images on event flow", false) &&
    localStorage.getItem("detection_classification") != "true"
  ) {
    let pic = null;
    if (image !== undefined)
      pic = (
        <Callout
          key={"img"}
          intent="primary"
          title={
            <span>
              <Trans>image captured on:</Trans>
              {mefDate(image.date)}
            </span>
          }
        >
          <img
            src={image.image}
            style={{ maxWidth: "100%" }}
            alt="vehicule capture"
          />
        </Callout>
      );
    else
      pic = (
        <Callout
          key={"img"}
          intent="warning"
          title={<Trans>transaction image</Trans>}
        >
          <p>
            <Trans>can't retreive the image of this movement</Trans>
          </p>
          <p>
            <Trans>
              the image could be purged according to the server settings
            </Trans>
          </p>
          <div className="flexbox-center">
            <Icon icon="unknown-vehicle" size="100" />
          </div>
        </Callout>
      );

    return (
      <span>
        <Tag
          className="licenseplate-little"
          icon="blank" /* use icon to adjust style like others Tags of event flow */
          interactive={true}
          onClick={() => {
            open(true);
            authenticatedGetFetch(
              "/alpr/image?" +
                new URLSearchParams({
                  srv: props.server,
                  park: props.park,
                  plate: props.plate,
                  date: props.date,
                  device: props.device,
                }),
              (res) => {
                setFetched(true);
                setImage(res);
              },
              null,
              undefined,
              () => {
                setFetched(true);
                setImage(undefined);
              }
            );
          }}
        >
          {mefPlate(props.plate)}
        </Tag>

        {/* dialog open on click on Tag */}
        <Dialog
          isOpen={isOpen}
          onClose={() => open(false)}
          onConfirm={() => open(false)}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          title={<Trans>transaction image</Trans>}
          icon="drive-time"
        >
          {dataFetched ? pic : <Spinner />}
        </Dialog>
      </span>
    );
  } else if (
    getSetting("display ALPR images on event flow", false) &&
    localStorage.getItem("detection_classification") == "true"
  ) {
    return (
      <span>
        <Tag
          className="licenseplate-little"
          icon="blank" /* use icon to adjust style like others Tags of event flow */
          interactive={true}
          onClick={() => {
            open(true);
            loading(true);
            authenticatedGetFetch(
              "/ow/dc/transaction?" +
                new URLSearchParams({
                  srv: props.server,
                  plate: props.plate,
                  date: new Date(props.date).toISOString(),
                  lane: props.device,
                }),
              (res) => {
                loading(false);
                setFetched(true);
                setImage(res);
              },
              null,
              undefined,
              () => {
                loading(false);
                setFetched(true);
                setImage(undefined);
              }
            );
          }}
        >
          {mefPlate(props.plate)}
        </Tag>

        {/* dialog open on click on Tag */}
        <Dialog
          isOpen={isOpen}
          onClose={() => open(false)}
          onConfirm={() => open(false)}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          title={<Trans>transaction image</Trans>}
          icon="drive-time"
        >
          {isLoading ? (
            <Spinner />
          ) : image === undefined ? (
            <Callout
              key={"img"}
              intent="warning"
              title={<Trans>transaction image</Trans>}
            >
              <p>
                <Trans>can't retreive the image of this movement</Trans>
              </p>
              <p>
                <Trans>
                  the image could be purged according to the server settings
                </Trans>
              </p>
              <div className="flexbox-center">
                <Icon icon="unknown-vehicle" size="100" />
              </div>
            </Callout>
          ) : (
            (image?.detections || []).map((d) => (
              <span key={d.id}>
                <Detection {...d} />
                <br />
              </span>
            ))
          )}
        </Dialog>
      </span>
    );
  } else {
    return (
      <Tag icon="blank" className="licenseplate-little">
        {mefPlate(props.plate)}
      </Tag>
    );
  }
}
